import AWS from 'aws-sdk';
import awsmobile from '../aws-exports';

async function GetAWSObjectURL(filePath) {
  const s3 = new AWS.S3({
    accessKeyId: process.env.REACT_APP_AWS_AccessKeyId,
    signatureVersion: 'v4',
    region: process.env.REACT_APP_AWS_Region,
    secretAccessKey: process.env.REACT_APP_AWS_SecretAccessKey
  });

  const signedUrlExpireSeconds = 60 * 10000;
  const url = s3.getSignedUrl('getObject', {
    Bucket: process.env.REACT_APP_AWS_Bucket,
    Key: filePath,
    Expires: signedUrlExpireSeconds
  });
  return url;
}

async function UploadFileOnS3(objFile, fileSavePath) {
  let isFileUploaded = false;
  const myS3UploadBucket = new AWS.S3({
    accessKeyId: process.env.REACT_APP_AWS_AccessKeyId,
    signatureVersion: 'v4',
    region: process.env.REACT_APP_AWS_Region,
    secretAccessKey: process.env.REACT_APP_AWS_SecretAccessKey,
    params: { Bucket: process.env.REACT_APP_AWS_Bucket }
  });
  const params = { ACL: 'public-read', Body: objFile, Key: fileSavePath };
  const data = myS3UploadBucket.putObject(params).send(async (err,data) => {
  
    if (err){
      console.log("err",err)
    }
    else {
      isFileUploaded = true;
    }
  });
  
  return isFileUploaded;
}

async function getCognitoUserById({ userId }) {
  AWS.config.update({
    accessKeyId: process.env.REACT_APP_AWS_AccessKeyId,
    signatureVersion: 'v4',
    region: process.env.REACT_APP_AWS_Region,
    secretAccessKey: process.env.REACT_APP_AWS_SecretAccessKey
  });
  try {
    const cognito = new AWS.CognitoIdentityServiceProvider();
    var params = {
      UserPoolId: awsmobile.aws_user_pools_id,
      Username: userId
    };
    const data = await cognito.adminGetUser(params).promise();
    return data;
  } catch (e) {
    throw e;
  }
}

async function getAllCognitoUsers() {
  AWS.config.update({
    accessKeyId: process.env.REACT_APP_AWS_AccessKeyId,
    signatureVersion: 'v4',
    region: process.env.REACT_APP_AWS_Region,
    secretAccessKey: process.env.REACT_APP_AWS_SecretAccessKey
  });
  try {
    const cognito = new AWS.CognitoIdentityServiceProvider();
    var params = {
      UserPoolId: awsmobile.aws_user_pools_id
    };
    const data = await cognito.listUsers(params).promise();

    return data;
  } catch (e) {
    throw e;
  }
}



//delete Object
async function GetAWSObjectDelete(filePath) {

        const s3 = new AWS.S3({
            accessKeyId: process.env.REACT_APP_AWS_AccessKeyId,
            signatureVersion: 'v4',
            region: process.env.REACT_APP_AWS_Region,
            secretAccessKey: process.env.REACT_APP_AWS_SecretAccessKey
        });
var params = {
  Bucket: process.env.REACT_APP_AWS_Bucket, 
  Key: filePath
 };
        const signedUrlExpireSeconds = 60 * 10000
        s3.deleteObject(params, function(err, data) {
   if (err) console.log(err, err.stack); // an error occurred
   else     console.log(data);           // successful response
   
 });
        

};

export { GetAWSObjectURL, UploadFileOnS3, getCognitoUserById, getAllCognitoUsers ,GetAWSObjectDelete};
